import angular from 'angular';
import { ConfiguracoesService } from '../../../Configuracoes/configuracoes.service';

export class NotificacoesIndexController {
    static $inject = ['$scope', 'ConfiguracoesService', 'NewToaster'];

    public afterExpirationConfig = {
        daysLimit: null as number | null,
    };
    public beforeExpirationConfig = {
        businessDaysBefore: null as number | null,
    };
    public notifyManager = false;
    public busy = true;
    public initialValues: {
        daysLimit: number | null;
        businessDaysBefore: number | null;
        notifyManager: boolean;
    } | null = null;

    constructor(
        private $scope: angular.IScope,
        private ConfiguracoesService: ConfiguracoesService,
        private NewToaster: any,
    ) {
        this.busy = true;
        this.ConfiguracoesService.reload();
        this.applyConfiguracoes(this.ConfiguracoesService.entities);

        this.$scope.$on('configuracoes_list_finished', (_event: angular.IAngularEvent, args: any) => {
            this.applyConfiguracoes(args);
            this.busy = false;
        });

        this.$scope.$on('configuracoes_submitted', (_event: angular.IAngularEvent, args: any) => {
            if (!this.isNotificacoesPayload(args?.entity)) {
                return;
            }
            const message = args?.response?.data?.message;
            if (message) {
                this.NewToaster.pop({
                    type: 'success',
                    title: message
                });
            }
            this.setInitialValues();
        });
    }

    salvarConfiguracoesNotificacoes() {
        const configs = ['NOTIFICAR_XDIAS_DEPOIS', 'NOTIFICAR_XDIAS_ANTES', 'NOTIFICAR_GESTOR'];
        const entities = this.ConfiguracoesService.entities || {};
        const payload = configs.map((chave) => {
            const existing = entities[chave] ? angular.copy(entities[chave]) : { chave, sistema: 'MEURH' };
            if (chave === 'NOTIFICAR_XDIAS_DEPOIS') {
                existing.valor = this.afterExpirationConfig.daysLimit != null
                    ? String(this.afterExpirationConfig.daysLimit)
                    : null;
            } else if (chave === 'NOTIFICAR_XDIAS_ANTES') {
                existing.valor = this.beforeExpirationConfig.businessDaysBefore != null
                    ? String(this.beforeExpirationConfig.businessDaysBefore)
                    : null;
            } else if (chave === 'NOTIFICAR_GESTOR') {
                existing.valor = this.notifyManager ? 'true' : 'false';
            }

            return existing;
        });

        this.ConfiguracoesService.save(payload, null);
    }

    hasChanges() {
        if (!this.initialValues) {
            return false;
        }

        return (
            this.afterExpirationConfig.daysLimit !== this.initialValues.daysLimit ||
            this.beforeExpirationConfig.businessDaysBefore !== this.initialValues.businessDaysBefore ||
            this.notifyManager !== this.initialValues.notifyManager
        );
    }

    private applyConfiguracoes(args: any) {
        if (!args) {
            return;
        }

        const config = args.NOTIFICAR_XDIAS_DEPOIS;
        if (config?.valor != null) {
            const parsed = parseInt(config.valor, 10);
            if (!Number.isNaN(parsed)) {
                this.afterExpirationConfig.daysLimit = parsed;
            }
        }

        const beforeConfig = args.NOTIFICAR_XDIAS_ANTES;
        if (beforeConfig?.valor != null) {
            const parsed = parseInt(beforeConfig.valor, 10);
            if (!Number.isNaN(parsed)) {
                this.beforeExpirationConfig.businessDaysBefore = parsed;
            }
        }

        const notifyConfig = args.NOTIFICAR_GESTOR;
        if (notifyConfig?.valor != null) {
            this.notifyManager = notifyConfig.valor === true || notifyConfig.valor === 'true';
        }

        if (args.NOTIFICAR_XDIAS_DEPOIS || args.NOTIFICAR_XDIAS_ANTES || args.NOTIFICAR_GESTOR || this.ConfiguracoesService.loaded) {
            this.busy = false;
        }

        this.setInitialValues();
    }

    private setInitialValues() {
        this.initialValues = {
            daysLimit: this.afterExpirationConfig.daysLimit,
            businessDaysBefore: this.beforeExpirationConfig.businessDaysBefore,
            notifyManager: this.notifyManager
        };
    }

    private isNotificacoesPayload(entity: any) {
        const keys = ['NOTIFICAR_XDIAS_DEPOIS', 'NOTIFICAR_XDIAS_ANTES', 'NOTIFICAR_GESTOR'];
        if (Array.isArray(entity)) {
            return entity.some((item) => keys.includes(item?.chave));
        }
        return keys.includes(entity?.chave);
    }
}
